import { RSAA } from 'redux-api-middleware'
import { map, mergeDeepRight, pick, pipe, prop } from 'ramda'
import {
  getApiPath,
  mapObjectKeys,
  toSentenceCase,
  webStorage,
} from 'sidecar-utility-library'

import { types, initialState } from './index'

export const fetchTransactionFilterOptions = () => ({
  [RSAA]: {
    endpoint: getApiPath(
      'exp',
      `members/subscription/transactions/filters?accountUuid=${webStorage.getItem(
        'aud',
      )}`,
    ),
    method: 'GET',
    types: [
      types.FETCH_TRANSACTION_FILTER_OPTIONS_REQUEST,
      types.FETCH_TRANSACTION_FILTER_OPTIONS_SUCCESS,
      types.FETCH_TRANSACTION_FILTER_OPTIONS_ERROR,
    ],
  },
})

export default (state = initialState, { type, payload = {} } = {}) => {
  switch (type) {
    case types.FETCH_TRANSACTION_FILTER_OPTIONS_REQUEST: {
      return {
        ...state,
        busy: true,
      }
    }

    case types.FETCH_TRANSACTION_FILTER_OPTIONS_SUCCESS: {
      const updatedFilterOptions = pipe(
        mapObjectKeys({
          billingTypes: pipe(
            prop('types'),
            map(type => ({
              name: toSentenceCase(type),
              label: toSentenceCase(type),
              value: type,
            })),
          ),
          paymentMethods: pipe(
            prop('paymentMethods'),
            map(paymentMethod => {
              switch (paymentMethod.type) {
                case 'ACCOUNT_CREDIT':
                  return {
                    name: paymentMethod.uuid,
                    label: 'Reimbursement Credit',
                    value: paymentMethod.uuid,
                  }
                case 'BANK_ACCOUNT':
                  return {
                    name: paymentMethod.uuid,
                    label: `${paymentMethod.bank} **${paymentMethod.last4}`,
                    value: paymentMethod.uuid,
                  }
                case 'CARD':
                  return {
                    name: paymentMethod.uuid,
                    label: `${paymentMethod.brand} **${paymentMethod.last4}`,
                    value: paymentMethod.uuid,
                  }
                case 'ACCOUNT_CREDIT_TAXABLE':
                  return {
                    name: paymentMethod.uuid,
                    label: 'Earned Benefit',
                    value: paymentMethod.uuid,
                  }
                default:
                  return {
                    label: 'Any',
                  }
              }
            }),
          ),
          transactions: pipe(
            prop('categories'),
            map(category => ({
              name: toSentenceCase(category),
              label: toSentenceCase(category),
              value: category,
            })),
          ),
          // At one point, the billing activity page ignored the members object
          // from this endpoint and used members from the members endpoint.
          members: pipe(
            prop('members'),
            map(member => ({
              name: member.uuid,
              label: `${member.firstName} ${member.lastName}`,
              value: member.uuid,
            })),
          ),
        }),
        pick(['billingTypes', 'members', 'paymentMethods', 'transactions']),
      )(payload)

      return {
        ...state,
        filterOptions: mergeDeepRight(state.filterOptions, {
          ...updatedFilterOptions,
        }),
        busy: false,
      }
    }

    case types.FETCH_TRANSACTION_FILTER_OPTIONS_ERROR: {
      return {
        ...state,
        busy: false,
        filterOptionError: payload.response.errors[0],
      }
    }

    default:
      return state
  }
}
